export default {
  "pl": {
    "space": {
      "actions": {
        "assignOtherUnit": "Ponownie przypisz do jednostki",
        "assignSpace": "Przypisz przestrzeń",
        "assignUnit": "Przypisz do jednostki",
        "cancel": "Cofnij",
        "closeEdit": "Zamknij okno edycji",
        "create_space": "Utwórz przestrzeń",
        "delete": "Usuń",
        "edit": "Edytuj",
        "goToSpaces": "Utwórz nowe przestrzenie",
        "new": "Nowa przestrzeń",
        "save": "Zapisz",
        "unassign": "Anuluj przypisanie jednostki",
        "unassignSpaces": "Anuluj przypisanie przestrzeni"
      },
      "attributes": {
        "category": "Rodzaj",
        "description": "Opis",
        "level": "Poziom",
        "name": "Nazwa",
        "price_value": "Łączna wartość sprzedaży",
        "price_value_construction": "Wartość inwestycji",
        "price_value_land": "Wartość gruntu",
        "quotity": "Część kwoty przelewu",
        "status": "Status",
        "unit": "Jednostka"
      },
      "category": {
        "bicyclestorage": "Miejsce na przechowywanie roweru",
        "cellar": "Piwnica",
        "garagebox": "Boks garażowy",
        "other": "Inne",
        "outdoor_space": "Przestrzeń zewnętrzna",
        "parkinglot": "Miejsce parkingowe",
        "storage": "Schowek ogólny",
        "winecellar": "Piwnica na wino"
      },
      "labels": {
        "allSpacesAssigned": "Wszystkie przestrzenie zostały przypisane do jednostki.",
        "assignedSpaces": "Przypisane przestrzenie",
        "internal": "Wewnętrzne",
        "noCategory": "Nie określono rodzaju",
        "noSpaceAssigned": "Nie przypisano przestrzeni",
        "noSpaces": "Nie utworzono przestrzeni",
        "notAssignedToUnit": "Nie przypisano jednostki",
        "onlyAvailableSpacesShown": "Widoczne są tylko dostępne przestrzenie",
        "selectToUnassign": "Wybierz, aby anulować przypisanie",
        "space": "Przestrzeń",
        "spaces": "Przestrzenie",
        "spacesProject": "Przestrzenie w projekcie: {project}",
        "unassignedSpaces": "Nieprzypisane przestrzenie"
      },
      "validation": {
        "needCategory": "Należy podać rodzaj",
        "needName": "Należy podać nazwę",
        "needNumber": "Należy podać liczbę (np. 95)",
        "selectSpace": "Wybierz przynajmniej 1 przestrzeń"
      }
    }
  }
}
